// TEMP-DESIGN-PREVIEW: delete this file, and the route in app.routes.ts that
// uses it, before committing.
//
// The onboarding page sits behind onboardingGuard, so it cannot be opened, let
// alone screenshotted, without a live session. These stubs stand in for the two
// services it reads from so the page renders every state (a number on the
// account, a running trial, a save that succeeds) against no API at all.
import { signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

export const authStub = {
  currentUser: signal({
    username: 'preview',
    email: 'preview@neotrader.in',
    email_verified: true,
    full_name: 'Amar Singh',
    phone_number: '9876543210',
    is_phone_verified: true,
    billing_email: null,
    profiling_completed: false,
    onboarding: { next_step: 'dashboard', missing: [] },
    timezone: 'Asia/Kolkata',
    theme: 'dark',
    updated_at: null,
  }),
  saveProfiling: (): Observable<any> =>
    of({ profiling_completed: true, message: 'ok' }).pipe(delay(700)),
};

export const subscriptionStub = {
  getMySubscription: (): Observable<any> =>
    of({
      plan_status: [
        {
          name: 'Genie',
          start_date: null,
          end_date: null,
          status: 'active',
          days_remaining: 4,
          is_trial: true,
        },
      ],
    }),
};
